import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import TemporaryPasswordResetForm from '../components/TemporaryPasswordResetForm';

const TemporaryPasswordResetPage = () => {
  return (
    <Container maxWidth="md">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" align="center" gutterBottom>
          Set Your Password
        </Typography>
        <Typography variant="body1" align="center" color="text.secondary" sx={{ mb: 4 }}>
          Please set a new password to continue using the system.
        </Typography>
        
        <TemporaryPasswordResetForm />
      </Box>
    </Container>
  );
};

export default TemporaryPasswordResetPage; 